module.exports = __webpack_public_path__ + "img/icons8-ask-question.9a4ee905.svg";